import React, { useState } from "react";
import { AnnsModal, Col } from "../Component";
import { Form } from "reactstrap";

const NMCPDFViewModal = ({ visible, url, onClosed, title = "View PDF" }) => {
    const [loading, setLoading] = useState(false);

    // Function to close the modal and reset states
    const close = () => {
        onClosed();
        setLoading(false);
    };

    // Construct the full PDF URL
    const getFullPdfUrl = () => {
        if (!url) return null;

        // If URL already starts with http/https, return as is
        if (url.startsWith("http://") || url.startsWith("https://")) {
            return url;
        }

        // Get base URL from environment
        const baseUrl = process.env.REACT_APP_API_PATH || "";

        // Remove trailing slash from base URL if present
        const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;

        // Ensure URL starts with / if it doesn't already
        const cleanUrl = url.startsWith("/") ? url : `/${url}`;

        return `${cleanBaseUrl}${cleanUrl}`;
    };

    const fullPdfUrl = getFullPdfUrl();

    return (
        <AnnsModal size={"xl"} isOpen={visible} toggle={close} title={title} loading={loading} isFooterHide>
            <Form className="row gy-4 form-validation">
                <Col md="12">
                    <div
                        style={{
                            border: "1px solid rgba(0, 0, 0, 0.3)",
                            height: "750px",
                            width: "100%",
                            overflow: "hidden",
                            borderRadius: "0.5rem",
                            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                        }}
                    >
                        {fullPdfUrl ? (
                            <iframe
                                src={fullPdfUrl}
                                title={title}
                                width="100%"
                                height="100%"
                                style={{ border: "none" }}
                                onLoad={() => setLoading(false)}
                            />
                        ) : (
                            <div className="p-4 text-center">No PDF available</div>
                        )}
                    </div>
                </Col>
            </Form>
        </AnnsModal>
    );
};

export default NMCPDFViewModal;
